import { createFileRoute } from "@tanstack/react-router";

import { ChatLayout } from "@/components/messages/ChatLayout";
import { AppError } from "@/lib/errors/app-error";
import {
  ROOT_ERROR_CATALOG,
  type RootErrorCatalogKey,
} from "@/lib/errors/root-error-catalog";

function Index() {
  return <ChatLayout />;
}

function isRootErrorCatalogKey(value: string): value is RootErrorCatalogKey {
  return Object.hasOwn(ROOT_ERROR_CATALOG, value);
}

/** Dev-only probe: `/?forceRootError=<catalogKey>` — see ROOT_ERROR_CATALOG keys. */
export const Route = createFileRoute("/_app/")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    forceRootError?: RootErrorCatalogKey;
  } => {
    if (!import.meta.env.DEV) return {};
    const raw = search.forceRootError;
    if (raw === true || raw === "1" || raw === "true") {
      return { forceRootError: "conversation_not_found" };
    }
    if (typeof raw === "string" && isRootErrorCatalogKey(raw)) {
      return { forceRootError: raw };
    }
    return {};
  },
  beforeLoad: ({ search }) => {
    if (!import.meta.env.DEV) return;
    const code = search.forceRootError;
    if (!code) return;
    throw new AppError(`Manual RootErrorView probe (${code})`, {
      code,
    });
  },
  component: Index,
});
